import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';

// Material ui
import Icon from 'material-ui/Icon';
import Drawer from 'material-ui/Drawer';
import List, { ListItem } from 'material-ui/List';

import s from './Navigation.css';
import Link from '../Link';

class Navigation extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      drawer: false,
    };

    this.toggleDrawer = this.toggleDrawer.bind(this);
  }

  toggleDrawer = open => () => {
    this.setState({
      drawer: open,
    });
  };

  render() {
    const { drawer } = this.state;

    const navItems = [
      {
        key: 'about',
        item: (
          <Link className={s.link} to="/om-kostradsguiden">
            {'Om kostrådsguiden'}
          </Link>
        ),
      },
      {
        key: 'quiz',
        item: (
          <Link className={s.link} to="/testet">
            {'Starta testet'}
          </Link>
        ),
      },
      {
        key: 'fact',
        item: (
          <Link className={s.link} to="/faktabank">
            {'Faktabank'}
          </Link>
        ),
      },
    ];

    return (
      <div className={s.root} role="navigation">
        <div className={s.desktop}>
          {navItems.map(m => <span key={m.key}>{m.item}</span>)}
        </div>
        <div className={s.mobile}>
          <button className={s.toggle} onClick={this.toggleDrawer(true)}>
            <Icon style={{ fontSize: '32px' }}>menu</Icon>
          </button>
        </div>
        <Drawer
          anchor="right"
          open={drawer}
          onRequestClose={this.toggleDrawer(false)}
        >
          <div tabIndex={0} role="button" onClick={this.toggleDrawer(false)}>
            <List>
              {navItems.map(m => <ListItem key={m.key}>{m.item}</ListItem>)}
            </List>
          </div>
        </Drawer>
      </div>
    );
  }
}

export default withStyles(s)(Navigation);



// WEBPACK FOOTER //
// ./src/components/Header/Navigation.js